
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { ProfileData } from '@/hooks/useProfiles';
import { useToast } from '@/hooks/use-toast';
import { transformProfileData } from './useProfileTransformer';

export const useProfileFetcher = (
  setProfiles: React.Dispatch<React.SetStateAction<ProfileData[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { toast } = useToast();

  const fetchProfiles = useCallback(async () => {
    try {
      setLoading(true);
      console.log('Fetching all profiles...');
      
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) {
        throw error;
      }
      
      if (data) {
        console.log(`Fetched ${data.length} profiles successfully`);
        
        // Transform the data to match the ProfileData interface
        const transformedData: ProfileData[] = data.map(profile => transformProfileData(profile));
        
        setProfiles(transformedData);
      }
    } catch (error: any) {
      console.error('Error fetching profiles:', error);
      toast({
        title: "Failed to load profiles",
        description: error.message || "Could not load user profiles",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  }, [setProfiles, setLoading, toast]);

  return { fetchProfiles };
};
